<template>
  <div
    :class="{ 'sub-header-button': true, 'router-link-active': isActive, 'd-flex': true, 'align-items-center': true }"
  >
    <router-link :to="to" class="d-flex align-items-center">
      <mdicon v-if="icon" :name="icon" class="mr-2 d-inline-block" />
      <span class="mr-3 d-inline-block">{{ name }}</span>
    </router-link>

    <router-link v-if="addTo" :to="addTo">
      <mdicon name="plus" size="24" />
    </router-link>
  </div>
</template>

<script lang="ts">
import type { RouterLink } from '@/types/Components/Router'
import { computed, defineComponent, type PropType } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name: 'SubHeaderButton',
  props: {
    to: {
      type: Object as PropType<RouterLink>,
      required: true,
    },
    addTo: {
      type: Object as PropType<RouterLink>,
      required: false,
      default: null,
    },
    icon: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const route = useRoute()
    const router = useRouter()

    const resolved = computed(() => router.resolve(props.to))
    const isActive = computed(() => route.path.startsWith(resolved.value.path))

    return { isActive }
  },
})
</script>
